export default __webpack_public_path__ + "static/media/butcher2.5d608807.png";